import React from "react";
import { Popover, PopoverPosition } from "@patternfly/react-core";
import { OutlinedQuestionCircleIcon } from "@patternfly/react-icons";

export default () => (
  <Popover
    position={PopoverPosition.auto}
    bodyContent={
      <div>
        Supported dateString formats are{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://tools.ietf.org/html/rfc2822#page-14"
        >
          IETF-compliant RFC 2822 timestamps
        </a>
        , and also strings in a{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15"
        >
          version of ISO8601
        </a>
        .
        <br />
        For example: 'Jan 01, 1970', or '1970-01-01T00:00:00Z' are both
        acceptable.
      </div>
    }
    aria-label="DateString helper popover"
    closeBtnAriaLabel="Close DateString helper popover"
  >
    <OutlinedQuestionCircleIcon />
  </Popover>
);
